module.exports = __webpack_public_path__ + "static/media/IndieFlower-Regular.0841af95.ttf";